import { MARKERS_ACTIONS } from "constants/Actions/Markers";

// Estado inicial del reducer
const aInitialState = {
    aMarkers: [],
    aMarkersList: [],
    nTotalPages: null,

    oMarker: null,

    bIsSuccess: false,
    bIsError: false,

    aMarkersSuggestion: [],
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los marcadores geneticos almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const MarkerReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case MARKERS_ACTIONS.GET:
            return { ...aState, aMarkers: oAction.data.data, nTotalPages: oAction.data.pages };
        case MARKERS_ACTIONS.GET_LIST:
            return { ...aState, aMarkersList: oAction.data.data, nTotalPages: oAction.data.pages };
        case MARKERS_ACTIONS.FIND:
            return { ...aState, oMarker: oAction.data };
        case MARKERS_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case MARKERS_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case MARKERS_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oMarker: null };
        case MARKERS_ACTIONS.SUGGESTION:
            return { ...aState, aMarkersSuggestion: oAction.data };
        case MARKERS_ACTIONS.SUGGESTION_CLEAN:
            return { ...aState, aMarkersSuggestion: [] };
        default:
            return aState;
    }
}
